<template>
    <div>
        <!-- <button-back/> -->
        <div  class="map_filter">
            <span style="display:none">{{ level.name }}</span>
            <div class="maphighlight__box torrevistahermosa">
                <h1 class="caption__select">
                    <span v-if="img && img.url">{{img.name}}</span>
                  <!--   <span>Seleccione un departamento, clic para ver detalles</span> -->
                </h1>
                <map-highlight  v-if="img && img.url" @activeDetailPiso="activeData" :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />
                <!-- <Button :img="img" :id="id" :desarrollo="desarrollo" :nivel="nivel" :levelId="levelId" :url="url" /> -->
                <!-- <div class="line_horizontal"></div> -->
                <h2 v-else> Imagen del plano no disponible por el momento</h2>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlight from "../../core/rediseno/MapHighlightPiso.vue";
//import ButtonBack from "../../core/ButtonBack";
//import Button from "../../core/Button.vue";

export default {
    name: "Piso",
    components: {
        MapHighlight,
       // Button,
        //ButtonBack,
    },
    data() {
        return {
            id: 50,
            levelId: this.$route.params.idPiso,
            type: "departamentos",
            desarrollo: "torrevistahermosapiso",
            arrFilteredLocations: [],
            nivel: "availability",
            url: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
            pisos: {
                "N-01": {
                    name: 'NIVEL-01',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/plano_N-01_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '964',
                    transform: '',
                    viewBox: '0 0 938 964'
                },
                PB: {
                    name: 'PB',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/Piso_PB_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '964',
                    transform: '',
                    viewBox: '0 0 938 964'
                },
                N01: {
                    name: 'NIVEL 01',
                    url: '',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N02: {
                    name: 'NIVEL 2',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N03: {
                    name: 'NIVEL 3',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N04: {
                    name: 'NIVEL 4',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N05: {
                    name: 'NIVEL 5',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N06: {
                    name: 'NIVEL 6',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N07: {
                    name: 'NIVEL 7',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N08: {
                    name: 'NIVEL 8',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N09: {
                    name: 'NIVEL 9',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N10: {
                    name: 'NIVEL 10',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N11: {
                    name: 'NIVEL 11',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N12: {
                    name: 'NIVEL 12',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N13: {
                    name: 'NIVEL 13',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N14: {
                    name: 'NIVEL 14',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N15: {
                    name: 'NIVEL 15',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N16: {
                    name: 'NIVEL 16',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N17: {
                    name: 'NIVEL 17',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N18: {
                    name: 'NIVEL 18',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N19: {
                    name: 'NIVEL 19',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                N20: {
                    name: 'NIVEL 20',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/Piso1_PH_bordes.jpg',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
            },
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
        };
    },
    computed: {
        ...mapGetters({
            locations: "getStatusA",
            level:"getStatusLevel",
            /* selected: 'getStatusA', */
            filterModelos: "getStatusFilterModelos",            
        }),
        development() {
            return { id: this.id, level: this.levelId };
        },
      img() {
          //console.log(this.level);
          let pisoSpace = this.level.name ? this.level.name : false
            if(pisoSpace){
                const piso = pisoSpace.replace(" ", '');
                const pisoSeleccionado = this.pisos[piso];
                return pisoSeleccionado;
            }else{
                return false
            }
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            return this.locations
        },
    },
    methods: {
        ...mapActions(["getAvailableLocations", "clearCoords", "getFilterModelos",]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        },
        activeData(){
            this.$emit('activeDetailPiso');
        }
    },
    async created() {
        /* await this.getAvailableLocations(this.development);
        this.getFilterModelos(this.existFilter) */
    },
    async beforeDestroy() {
        /* await this.clearCoords(); */
    },
    mounted() {

    }
};
</script>
<style>
@media(min-width:1201px){
    .maphighlight__box.torrevistahermosa .box__svg-deptos{
        width:70%!important;
        min-height: auto!important;
    }
    .torrevistahermosa {
        margin-top: -37px;
    }
}
</style>
